import { useEffect, useState } from 'react';

import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';

import {
  useVehiclesListQuery,
  VehicleRead,
} from 'src/common/external/bambi-api/bambiApi';
import { FormFieldController } from 'src/common/FormField/FormFieldController';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export function VehicleSelectionField({
  onlySchedulable,
}: {
  onlySchedulable?: boolean;
}) {
  const { data: vehicles, isFetching } = useVehiclesListQuery({
    canBeScheduled: onlySchedulable,
  });
  const [vehicleOptions, setVehicleOptions] = useState<SelectOption[]>([]);

  useEffect(() => {
    if (vehicles?.results)
      setVehicleOptions(
        vehicles.results.map((vehicle: VehicleRead) => {
          return {
            label: vehicle.nickname || vehicle.id,
            value: vehicle.id,
          };
        })
      );
  }, [vehicles]);
  return (
    <div>
      <FormFieldController
        name="vehicle"
        rules={{ required: 'Vehicle is required' }}
      >
        {({ field, fieldState }) => {
          return (
            <DefaultFormFieldLayout
              label="Vehicle"
              error={fieldState.error?.message?.toString()}
              inputId="vehicle-id"
            >
              <Select
                selected={field.value}
                options={vehicleOptions}
                onChange={field.onChange}
                placeholder={
                  isFetching ? 'Loading vehicles...' : 'Select a vehicle'
                }
                disabled={isFetching}
              />
            </DefaultFormFieldLayout>
          );
        }}
      </FormFieldController>
    </div>
  );
}
